<template>
  <div class="card" style="min-height: 400px">
  <div class="bg-blue-light p-1">
    <TitleButton
        :showBtn="false"
        title="Attendance Deduction Early Exit"
        btnTitle="Add New"
        :showAddNew="true"
        @onClickAddNewButton="onClickAddNewButton"
    />
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th>Branch</th>
        <th>Department</th>
        <th>Employee</th>
        <th>Calculation Type</th>
        <th>Value</th>
        <th>Rounding Type</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.branch_name }}</td>
          <td>{{ item.department_name }}</td>
          <td>{{ item.contact_profile_name }}</td>
          <td class="text-capitalize">{{ item.calculation_type }}</td>
          <td class="text-right">{{ item.value }}</td>
          <td class="text-capitalize">{{ item.rounding_type }}</td>
          <td>
            <button class="btn btn-primary btn-sm"
                    @click="openEditModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="tableItems.length < 1" class="text-center mt-5">No data</p>
  </div>

  <div class="px-2 position-absolute bottom-0 mt-4">
    <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
  </div>

  <PayrollPreferenceAddModal
      v-if="isModalOpen"
      @close="isModalOpen = false"
      :formData="formData"
      @getData="getPayrollPreferenceData"
      :title="'Early Exit'"
  />
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import PayrollPreferenceAddModal from '@/components/molecule/company/hrm-payroll/payroll-preference/PayrollPreferenceAddModal.vue';
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {inject, onMounted, ref} from "vue";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const tableItems = ref([]);
const params = ref({
  offset: 10,
});
const loading = ref(false)
const router = useRouter();
const isModalOpen = ref(false);

let formInput = {
  company_id:route.params.companyId,
  branch_id:null,
  department_id:null,
  contact_profile_id:null,
  type:'attendance_deduction',
  sub_type:'early_exit',
  effective_date:null,
  calculation_type:'days',
  value:null,
  rounding_type:null,
  is_edit:false,
}

const formData = ref({ ...formInput })

const {
  fetchPayrollPreferenceList,
  fetchSinglePayrollPreference
} = handleHrPayroll()

function onClickAddNewButton() {
  formData.value = { ...formInput }
  isModalOpen.value = true;
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayrollPreferenceData();
}
const getPayrollPreferenceData = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []

  await fetchPayrollPreferenceList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }
    tableItems.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const openEditModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSinglePayrollPreference(item.id, query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    formData.value.contact_profile_id = {
      id: data.contact_profile_id,
      name: data.contact_profile_name
    };
    formData.value.branch_id = data.branch_id;
    formData.value.department_id = data.department_id;
    formData.value.type = data.type;
    formData.value.sub_type = data.sub_type;
    formData.value.effective_date = data.effective_date;
    formData.value.calculation_type = data.calculation_type;
    formData.value.value = data.value;
    formData.value.rounding_type = data.rounding_type;
    formData.value.is_edit = true;
    formData.value.id = data.id;
  });

  isModalOpen.value = true;
}


const getQuery = () => {
  let query = `?company_id=${route.params.companyId}&type=attendance_deduction&sub_type=early_exit`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  return query;
}

onMounted(() => {
  Promise.all([
    getPayrollPreferenceData(),
  ])
})

</script>